// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const FilterButton: React.FC<{ size?: number; color1?: string; className?: string }> = ({ size = 11, className }) => (
    <svg className={className} focusable="false" viewBox="0 0 11 11" width={size} height={size}>
        <path
            fill="currentColor"
            d="M0 9.052a.34.34 0 0 0 .344.334h1.41c.158.76.852 1.333 1.684 1.333.83 0 1.525-.573 1.684-1.333h5.534A.34.34 0 0 0 11 9.052a.34.34 0 0 0-.344-.333H5.122c-.16-.76-.853-1.333-1.684-1.333-.832 0-1.526.573-1.685 1.333H.343A.34.34 0 0 0 0 9.052m2.406 0c0-.357.197-.687.516-.866a1.06 1.06 0 0 1 1.031 0c.32.179.516.51.516.866a1 1 0 0 1-.516.866 1.06 1.06 0 0 1-1.031 0 1 1 0 0 1-.516-.866M6.531 5.72c0-.357.197-.687.516-.866a1.06 1.06 0 0 1 1.031 0c.32.179.516.509.516.866a1 1 0 0 1-.516.866 1.06 1.06 0 0 1-1.031 0 1 1 0 0 1-.516-.866m1.032-1.667c-.832 0-1.526.573-1.685 1.334H.344A.34.34 0 0 0 0 5.719a.34.34 0 0 0 .344.333h5.534c.16.76.853 1.334 1.685 1.334.83 0 1.525-.573 1.684-1.334h1.41A.34.34 0 0 0 11 5.72a.34.34 0 0 0-.344-.333h-1.41c-.158-.76-.852-1.334-1.683-1.334m-3.438-.666c-.368 0-.709-.19-.893-.5a.97.97 0 0 1 0-1c.184-.31.525-.5.893-.5s.709.19.893.5.184.69 0 1-.525.5-.893.5m1.684-1.334C5.65 1.292 4.956.72 4.125.72S2.6 1.292 2.441 2.052H.344A.34.34 0 0 0 0 2.386a.34.34 0 0 0 .344.333H2.44c.159.76.853 1.333 1.684 1.333S5.65 3.48 5.809 2.72h4.847A.34.34 0 0 0 11 2.386a.34.34 0 0 0-.344-.334z"
        />
    </svg>
);

export default React.memo(FilterButton);
